import React from "react";
import { Icon } from "antd";

export default ({color, onClick, text, minWidth = 300, fontSize = 16 })=>{
	const iconStyle = {color, cursor:"pointer", alignSelf:"center"};
	return (<div style={{ fontSize, display:"flex" }}>
		<Icon style={iconStyle} onClick={() => onClick(-1)} type="left-circle" />
		<span style={{ minWidth, margin: "0 10px 0 10px", textAlign:"center" }}>{text}</span>
		<Icon style={iconStyle} onClick={() => onClick(1)} type="right-circle" />
	</div>);
};


// WEBPACK FOOTER //
// ./src/components/bar/DatePagination.js